import { useMutation, useQueryClient } from "@tanstack/react-query";
import camelcaseKeys from "camelcase-keys";
import snakecaseKeys from "snakecase-keys";

import {
  authorizedGet,
  authorizedPatch,
  authorizedPost,
} from "../../authorizedRequests";
import { Customer } from "../Customer/schema";
import { billSplitKeys } from "./queries";
import {
  BillSplit,
  BillSplitSchema,
  CustomerSession,
  CustomerSessionSchema,
} from "./schema";

const deepCamelcaseKeys = (obj: any) => camelcaseKeys(obj, { deep: true });
export const fetchSession = async ({
  customerTabUuid,
}: {
  customerTabUuid: string;
}): Promise<BillSplit | null> => {
  try {
    const res = await authorizedGet({
      url: `/v1/customer_tabs/${customerTabUuid}/bill_split`,
    });
    if (res.body.bill_split === null) return null;

    const bill_split = BillSplitSchema.parse(
      deepCamelcaseKeys(res.body.bill_split),
    );
    return bill_split;
  } catch (e) {
    console.log("error fetching session", e);
    throw e;
  }
};

export const createSession = async ({
  customerTabUuid,
}: {
  customerTabUuid: string;
}): Promise<BillSplit> => {
  const res = await authorizedPost({
    url: `/v1/customer_tabs/${customerTabUuid}/bill_split`,
    body: {},
  });
  const session = BillSplitSchema.parse(deepCamelcaseKeys(res.body.bill_split));
  return session;
};

export const createCustomerSessionForSelf = async ({
  billSplitUuid: billSplitUuid,
}: {
  billSplitUuid: string;
}): Promise<CustomerSession> => {
  const res = await authorizedPost({
    url: `/v1/bill_splits/${billSplitUuid}/customer_sessions`,
    body: {
      customer_session: {},
    },
  });
  const customerSession = CustomerSessionSchema.parse(
    deepCamelcaseKeys(res.body.customer_session),
  );
  return customerSession;
};
